import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Instagram, Linkedin } from "lucide-react";
import {logoTransparent} from "./images";

export const SocialLinks = ({ iconSize = "w-8 h-8" }) => (
    <div className="flex items-center gap-4">
        <a
            href="mailto:operations@lastcallforbars.com"
            className="text-[#2D0075] hover:text-[#200056] transition-colors"
            title="Contact Operations"
        >
            <Mail className={iconSize} />
            <span className="sr-only">Email Operations</span>
        </a>
        <Link
            to="https://www.instagram.com/lastcallforbars?igsh=MWxmYzBibzA3dHE2Yw=="
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#2D0075] hover:text-[#200056] transition-colors"
        >
            <Instagram className={iconSize} />
            <span className="sr-only">Follow us on Instagram</span>
        </Link>
        <Link
            to="https://www.linkedin.com/company/lastcallforbars/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#2D0075] hover:text-[#200056] transition-colors"
        >
            <Linkedin className={iconSize} />
            <span className="sr-only">Connect with us on LinkedIn</span>
        </Link>
    </div>
);

export const FooterLinks = ({ className = "", setIsLoginOpen }) => (
    <div className={`grid grid-cols-2 gap-2 md:text-right ${className}`}>
        <a 
            href="https://calendar.app.google/64qw1CsuCwEXYG1v9 " 
            target="_blank" 
            rel="noopener noreferrer" 
            className="text-[#2b0062] text-lg md:text-base font-medium hover:underline"
        >
            Get a Demo
        </a>
        <Link 
            to="/locations" 
            className="text-[#2b0062] text-lg md:text-base font-medium hover:underline"
            onClick={() => window.scrollTo(0, 0)}
        >
            Locations
        </Link>
        <Link 
            to="/faq" 
            className="text-[#2b0062] text-lg md:text-base font-medium hover:underline" 
            onClick={() => window.scrollTo(0, 0)}
        >
            FAQ
        </Link>
        <button 
            onClick={() => setIsLoginOpen(true)} 
            className="text-[#2b0062] text-lg md:text-base font-medium hover:underline" 
        >
            Log In
        </button>
        <a 
            href="https://calendar.app.google/64qw1CsuCwEXYG1v9 " 
            target="_blank" 
            rel="noopener noreferrer" 
            className="text-[#2b0062] text-lg md:text-base font-medium hover:underline"
        >
            Join Us
        </a>
        <Link 
            to="/about-us" 
            className="text-[#2b0062] text-lg md:text-base font-medium hover:underline" 
            onClick={() => window.scrollTo(0, 0)}
        >
            About Us
        </Link>
    </div>
);

export const PrivacyTerms = ({ className = "" }) => (
    <div className={`flex justify-between items-center px-4 ${className}`}>
        <div className="flex items-center gap-4">
            <Link to="/privacy-policy" className="text-sm text-[#2b0062] hover:underline" onClick={() => window.scrollTo(0, 0)}>
                Privacy Policy
            </Link>
            <p className="text-sm text-[#2b0062]">|</p>
            <Link to="/terms-and-conditions" className="text-sm text-[#2b0062] hover:underline" onClick={() => window.scrollTo(0, 0)}>
                Terms & Conditions
            </Link>
        </div>
        <div className="flex items-center gap-4">
            <p className="text-sm text-[#2b0062]">2025</p>
            <p className="text-sm text-[#2b0062]">|</p>
            <p className="text-sm text-[#2b0062]">New York, NY</p>
        </div>
    </div>
);

export const MobileFooterContent = ({ setIsLoginOpen }) => (
    <div className="flex flex-col items-center gap-6">
        <div className="text-center mb-2">
            <h2 className="text-[#2b0062] text-3xl font-[500]">
                Instant Texts, Instant Crowds
            </h2>
        </div>

        {/* Logo Section */}
        <div className="flex flex-col items-center gap-2">
            <div className="w-[160px]">
                <img src={logoTransparent} alt="LastCall logo" className="w-full h-full object-contain" />
            </div>
            <SocialLinks iconSize="w-5 h-5" />
        </div>

        {/* Links Section */}
        <div className="w-full">
            <FooterLinks 
                className="text-center justify-center max-w-[300px] mx-auto"
                setIsLoginOpen={setIsLoginOpen}
            />
        </div>
    </div>
);

export const FooterComponents = ({ isMobile, setIsLoginOpen }) => (
    <footer className={isMobile ? "md:hidden w-full" : "hidden md:block w-full"}>
      <div className="max-w-[2000px] mx-auto px-12">
        {/* Purple Section */}
        <div className="w-full bg-[#2b0062] bg-opacity-15 rounded-xl">
          {isMobile ? (
            <div className="px-8 py-6">
              <MobileFooterContent setIsLoginOpen={setIsLoginOpen} />
            </div>
          ) : (
            <div className="grid md:grid-cols-3 gap-4 items-center px-12 py-3">
              {/* Logo Section */}
              <div className="flex flex-col items-center gap-2 w-[200px]">
                <div className="w-[160px]">
                  <img src={logoTransparent} alt="LastCall logo" className="w-full h-full object-contain" />
                </div>
                <SocialLinks iconSize="w-5 h-5" />
              </div>

              <div className="flex items-center justify-center">
                <h2 className="text-[#2b0062] text-2xl font-[500]">
                  Instant Texts, Instant Crowds
                </h2>
              </div>

              {/* Links Section */}
              <div className="flex flex-col items-end">
                <FooterLinks 
                  className="text-decoration-color-[#2b0062] decoration-solid"
                  setIsLoginOpen={setIsLoginOpen}
                />
              </div>
            </div>
          )}
        </div>

        {/* Bottom Section */}
        <div className="w-full border-t border-[#2b0062] border-opacity-20 mt-4">
          <div className="w-full py-2">
            <PrivacyTerms className="max-w-full" />
          </div>
        </div>
      </div>
    </footer>
); 